module.exports = __webpack_public_path__ + "media/images/bg/hero/camps-07bfcb051a333256214f58daad3d40b6.webp";